import { trigger, transition, style, animate } from '@angular/animations';

export const slideInAnimation = trigger('slideIn', [
  transition(':enter', [
    style({ transform: 'translateY(-30%)', opacity: 0 }),
    animate('0.2s ease-in-out', style({ transform: 'translateY(0)', opacity: 1 })),
  ]),
]);
